export const FIELD_NAMES = {
  BOOL: 'bool',
  QUERY: 'query',
  MATCH: 'match',
  SEARCH_OPTION: 'searchOption',
};
export const ROW_COUNT = 6;
export const BOOLEAN_OPERATORS = {
  AND: 'and',
  OR: 'or',
  NOT: 'not',
};
export const QUERY_OPTION_VALUE = 'advancedSearch';
export const DEFAULT_SEARCH_OPTION = 'keyword';
export const MATCH_OPTIONS = {
  EXACT_PHRASE: 'exactPhrase',
  CONTAINS_ALL: 'containsAll',
  STARTS_WITH: 'startsWith',
  CONTAINS_ANY: 'containsAny',
};
